import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
    Avatar,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Popper,
    Paper,
    MenuList,
    MenuItem,
    ClickAwayListener,
    Grow,
    Typography,
    makeStyles,
    IconButton,
    Divider,
    Chip
} from '@material-ui/core'
import {
    AssignmentLateOutlined,
    MoreHoriz,
    PersonAddDisabledRounded,
    PersonAddRounded,
    Delete
} from '@material-ui/icons'
// import GetAppIcon from '@material-ui/icons/GetApp';
import moment from 'moment'
import firebase from 'firebase/app'

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary
    },
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        '&:hover': {
            cursor: 'pointer'
        }
    },
    avatar: {}
}))

const UserCard = ({ className, user, list, setUsers, ...rest }) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
    }

    async function makeUserDisable(id) {
        const updateStatus = firebase
            .firestore()
            .doc(`users/${id}`)
            .update({ disabled: true, banned: true })

        const updateAuthStatus = firebase
            .functions()
            .httpsCallable('disableUser-DisableUser')({
            id,
            status: true
        })

        await Promise.all([updateStatus, updateAuthStatus])
            .then(() => {
                const updatedUsers = list.map((data) => {
                    if (data.id === id) {
                        return {
                            ...data,
                            banned: true,
                            disabled: true
                        }
                    } else return data
                })
                setUsers(updatedUsers)
            })
            .catch((e) => console.log('ERRORRR', e))
    }

    async function makeUserEnable(id) {
        const updateStatus = firebase
            .firestore()
            .doc(`users/${id}`)
            .update({ disabled: false, banned: false })

        const updateAuthStatus = firebase
            .functions()
            .httpsCallable('disableUser-DisableUser')({
            id,
            status: false
        })

        await Promise.all([updateStatus, updateAuthStatus]).then(() => {
            const updatedUsers = list.map((data) => {
                if (data.id === id) {
                    return {
                        ...data,
                        banned: false,
                        disabled: false
                    }
                } else return data
            })
            setUsers(updatedUsers)
        })
    }

    function banUser(user) {
        if (
            window.confirm(
                `Do you really want to ${
                    user.disabled === false ? 'ban' : 'enable'
                } the user?`
            )
        ) {
            user.disabled === false
                ? makeUserDisable(user.id)
                : makeUserEnable(user.id)
        }
    }

    function deleteUser(id) {
        if (
            window.confirm(
                'Do you really want to delete the user? This action cannot be undone later.'
            )
        ) {
            return firebase
                .functions()
                .httpsCallable('deleteUser-DeleteUser')(id)
                .then(() => {
                    const updatedUsers = list.map((user) => {
                        if (user.id === id) {
                            return {
                                ...user,
                                deleted: true,
                                disabled: true
                            }
                        } else return user
                    })
                    setUsers(updatedUsers)
                })
                .catch((e) => console.log('DELETED FAILED', e))
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <img
                            src={user.photoURL}
                            alt={user.name + '_' + user.surname}
                            style={{ width: '100%', objectFit: 'cover' }}
                        />
                    </Avatar>
                }
                action={
                    user.deleted ? null : (
                        <>
                            <IconButton
                                ref={anchorRef}
                                aria-controls={
                                    open ? 'menu-list-grow' : undefined
                                }
                                aria-haspopup="true"
                                onClick={handleToggle}
                            >
                                <MoreHoriz />
                            </IconButton>

                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{
                                            transformOrigin:
                                                placement === 'bottom'
                                                    ? 'center top'
                                                    : 'center bottom'
                                        }}
                                    >
                                        <Paper>
                                            <ClickAwayListener
                                                onClickAway={handleClose}
                                            >
                                                <MenuList
                                                    autoFocusItem={open}
                                                    id="menu-list-grow"
                                                    onKeyDown={
                                                        handleListKeyDown
                                                    }
                                                >
                                                    <MenuItem
                                                        onClick={() =>
                                                            banUser(user)
                                                        }
                                                    >
                                                        {user.disabled ===
                                                        false ? (
                                                            <PersonAddDisabledRounded
                                                                style={{
                                                                    marginRight: 10
                                                                }}
                                                            />
                                                        ) : (
                                                            <PersonAddRounded
                                                                style={{
                                                                    marginRight: 10
                                                                }}
                                                            />
                                                        )}
                                                        {user.disabled === false
                                                            ? 'Ban User'
                                                            : 'Enable User'}
                                                    </MenuItem>
                                                    <MenuItem
                                                        onClick={() =>
                                                            deleteUser(user.id)
                                                        }
                                                    >
                                                        <Delete
                                                            style={{
                                                                marginRight: 10
                                                            }}
                                                        />
                                                        Delete
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </>
                    )
                }
                title={user.name + '  ' + user.surname}
                subheader={user.id}
            />

            <CardContent style={{ paddingTop: !user.picture && 0 }}>
                <Typography>
                    <Typography variant="span">Age: </Typography>{' '}
                    {moment(new Date()).diff(user.birthDate.toDate(), 'y')}
                </Typography>
                {user.gender ? (
                    <Typography>
                        <Typography variant="span">Gender: </Typography>
                        {user.gender}
                    </Typography>
                ) : null}
                {user.bio ? (
                    <Typography>
                        <Typography variant="span">Bio: </Typography>
                        {user.bio}
                    </Typography>
                ) : null}
                {user.veganismType ? (
                    <Typography>
                        <Typography variant="span">Veganism Type: </Typography>
                        {user.veganismType}
                    </Typography>
                ) : null}
                {user.coordinatesName ? (
                    <Typography>
                        <Typography variant="span">Location: </Typography>
                        {user.coordinatesName}
                    </Typography>
                ) : null}
                {user.occupation ? (
                    <Typography>
                        <Typography variant="span">Occupation: </Typography>
                        {user.occupation}
                    </Typography>
                ) : null}
                {user.education ? (
                    <Typography>
                        <Typography variant="span">Education: </Typography>
                        {user.education}
                    </Typography>
                ) : null}
                {user.tagline ? (
                    <Typography>
                        <Typography variant="span">Tagline: </Typography>
                        {user.tagline}
                    </Typography>
                ) : null}
                {user.badges && user.badges.length > 0 ? (
                    <>
                        <Typography>Badges:</Typography>
                        <div style={{ display: 'flex' }}>
                            {user.badges.map((item) => (
                                <Chip
                                    key={item}
                                    label={item}
                                    size="small"
                                    color="primary"
                                />
                            ))}
                        </div>
                    </>
                ) : null}
            </CardContent>

            <Divider />
            <CardActions disableSpacing>
                <>
                    <IconButton aria-label="show more">
                        <AssignmentLateOutlined />
                    </IconButton>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        {user.reportCount ? user.reportCount : 0}
                    </Typography>
                </>
                <div style={{ marginLeft: 'auto' }}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        Status:{'  '}
                        <Chip
                            color={
                                user.disabled === false ? 'primary' : 'default'
                            }
                            label={
                                user.disabled === false ? 'active' : 'disable'
                            }
                            size="small"
                        />
                        {user.banned ? (
                            <Chip
                                size="small"
                                label="banned"
                                style={{
                                    backgroundColor: 'red'
                                }}
                            />
                        ) : null}
                    </Typography>
                </div>
            </CardActions>
        </Card>
    )
}

UserCard.propTypes = {
    className: PropTypes.string,
    user: PropTypes.object.isRequired,
    list: PropTypes.array,
    setUsers: PropTypes.func
}

export default UserCard
